import DEFAULT from 'assets/themes/default_theme.png';
import BLUE from 'assets/themes/blue_theme.png';
import GREEN from 'assets/themes/green_theme.png';
import WHITE from 'assets/themes/white_theme.png';
import BLACK_YELLOW from 'assets/themes/black_yellow_theme.png';
import BLACK from 'assets/themes/black_theme.png';

const shadowOnActive = true;
const tableHeadersColor = '#50CBCC';
const themeList = [
  {
    logo: DEFAULT,
    theme: 'DEFAULT_THEME',
    label: 'Default theme',
    // Light theme, same purple/violet family the app has always used (was #620062/#800080),
    // just a light tint instead of a dark block so it sits comfortably next to the app's
    // light background.
    sidebarColor: '#FAF5FD',
    sidebarLabelColor: '#4A2E6B',
    activeItemColor: '#EDE1F7',
    activeItemLabelColor: '#7B1FA2',
    // Button/Tab
    buttonColor: '#7B1FA2',
    buttonBorderColor: '', // Use in-cas-of buttonColor is empty
    buttonLabelColor: '#FFFFFF',
    activeTabColor: '#7B1FA2',
    activeTabBorderColor: '#7B1FA2',
    // Common
    shadowOnActive: false,
    tableHeadersColor: '#7B1FA2',
  },
  {
    logo: BLUE,
    theme: 'BLUE_THEME',
    label: 'Blue theme',
    sidebarColor: '#0E9CF6',
    sidebarLabelColor: '#FFFFFF',
    activeItemColor: '#1292F4',
    activeItemLabelColor: '#FFFFFF',
    // Button/Tab
    buttonColor: '#0E9AD4',
    buttonBorderColor: '',
    buttonLabelColor: '#FFFFFF',
    activeTabColor: '#0E9AD4',
    activeTabBorderColor: '#0E9AD4',
    // Common
    shadowOnActive: false,
    tableHeadersColor,
  },
  {
    logo: GREEN,
    theme: 'GREEN_THEME',
    label: 'Green theme',
    sidebarColor: '#05613A',
    sidebarLabelColor: '#FFFFFF',
    activeItemColor: '#2B7858',
    activeItemLabelColor: '#FFFFFF',
    // Button/Tab
    buttonColor: '#00966A',
    buttonBorderColor: '',
    buttonLabelColor: '#FFFFFF',
    activeTabColor: '#00966A',
    activeTabBorderColor: '#00966A',
    // Common
    shadowOnActive,
    tableHeadersColor,
  },
  {
    logo: WHITE,
    theme: 'WHITE_THEME',
    label: 'White theme',
    sidebarColor: '#FFFFFF',
    sidebarLabelColor: '#414247',
    activeItemColor: '#F3F1F0',
    activeItemLabelColor: '#414247',
    // Button/Tab
    buttonColor: '#FE4C24',
    buttonBorderColor: '',
    buttonLabelColor: '#FFFFFF',
    activeTabColor: '#FE4C24',
    activeTabBorderColor: '#FE4C24',
    // Common
    shadowOnActive,
    tableHeadersColor,
  },
  {
    logo: BLACK_YELLOW,
    theme: 'BLACK_YELLOW_THEME',
    label: 'Black yellow theme',
    // Sidebar
    sidebarColor: '#1C212D',
    sidebarLabelColor: '#EEF0F8',
    activeItemColor: '#FED832',
    activeItemLabelColor: '#112C11',
    // Button/Tab
    buttonColor: '',
    buttonBorderColor: '#2B5755',
    buttonLabelColor: '#2B5755',
    activeTabColor: '#1C212D',
    activeTabBorderColor: '#FED832',
    // Common
    shadowOnActive,
    tableHeadersColor,
  },
  {
    logo: BLACK,
    theme: 'BLACK_THEME',
    label: 'Black theme',
    sidebarColor: '#333338',
    sidebarLabelColor: '#FCFCFC',
    activeItemColor: '#E3306F',
    activeItemLabelColor: '#FFFFFF',
    // Button/Tab
    buttonColor: '#E3306E',
    buttonBorderColor: '',
    buttonLabelColor: '#FFFFFF',
    activeTabColor: '#E3306E',
    activeTabBorderColor: '#E3306E',
    // Common
    shadowOnActive,
    tableHeadersColor,
  },
];

export { themeList };
